<template>
        <div class="row">
            <div class="col-12">
                <div class="text-primary font-weight-normal d-block font-weight-bold h2 text-center font-family-sans-serif py-2" style="background-color: #E6E6E6;">
                    {{$t('linked_race.title')}}
                </div>
            </div>

    <div class="container" v-if="data && data.LinkedRaces.length">


            <table class="table table-striped">
                <tbody>

                    <tr v-for="gara in data.LinkedRaces" :key="gara.ID" @click="goToRace(gara.ID)">
                        <td><span class="race-year">{{gara.RaceDate | year}}</span></td>
                        <td>{{gara.RaceDate | days}}</td>
                        <td>{{gara.Description}}</td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LinkedRace",
        props: [
            'data'
        ], data() {
            return {
                publicPath: process.env.BASE_URL,
            }
        },
                    methods: {
                goToRace(id) {
                    this.$router.push({ name: 'race', params: { id: id } });
                }
            }
    }
</script>

<style scoped>

</style>
